import { render, staticRenderFns } from "./orderExternalSetupBar.vue?vue&type=template&id=72e0f37e&"
import script from "./orderExternalSetupBar.vue?vue&type=script&lang=js&"
export * from "./orderExternalSetupBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports